<template>
  <div>
    <BlockHeader name="PDF settings" />
    <div class="row">
      <div class="col-lg-4 col-sm-12 col-xs-12">
        <div class="col-lg-12 col-sm-12 col-xs-12 p-0">
          <Select
            v-model="settingsLocal.pdfTranslationLanguage"
            :options="lngOptions"
            form-group-id="PDF translation language"
            placeholder="PDF translation language"
            :tile-size="11"
          />
        </div>
        <Select v-model="settingsLocal.presetType" :options="presetOption" form-group-id="Preset" placeholder="Preset" />
      </div>
      <div v-for="item in imagePreview" :key="item.key" class="col-lg-4 col-sm-12 col-xs-12 mb-5">
        <FileInput v-model="settingsLocal[item.key]" :form-group-id="item.title" :placeholder="labels[item.key]" />
        {{ item.title }}
        <div class="img-wrapper">
          <!-- ?dummy=${Math.random() added for avoid caching  -->
          <img
            v-show="previewPdfLoaded[item.key]"
            :src="`${baseURL}/api/v1/static/pdf-templates/${previewPdf[item.key]}?dummy=${Math.random()}`"
            alt="No pdf template"
            class="img-preview"
            @error="errorImgLoaded(item.key)"
            @load="imgLoaded(item.key)"
          />
          <div v-show="!previewPdfLoaded[item.key]">No pdf template found for this preset</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { ApiMixin } from '../../../../../mixins';

import Select from '../../../common/select/index';
import FileInput from '../../../common/fileInput/index';
import BlockHeader from '../../../common/block-header';

export default {
  name: 'GeneralSettings',
  components: { BlockHeader, Select, FileInput },
  mixins: [ApiMixin],
  props: {
    settings: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      baseURL: axios.defaults.baseURL,
      labels: { bgFirst: 'First page', bgFollowing: 'Following pages' },
      bgImages: { bgFirst: null, bgFollowing: null },
      imagePreview: [
        { key: 'bgFirst', title: 'Header for the first page' },
        { key: 'bgFollowing', title: 'Header for all the following pages' },
      ],
      previewPdfLoaded: {
        bgFirst: true,
        bgFollowing: true,
      },
      lngOptions: [
        { value: 'EN', text: 'English' },
        { value: 'DE', text: 'German' },
        { value: 'JA', text: 'Japanese' },
      ],
      presetOption: [
        { value: 'orders', text: 'Orders' },
        { value: 'reports', text: 'Reports' },
        { value: 'statistics', text: 'Statistics' },
      ],
    };
  },
  computed: {
    settingsLocal: {
      get: function () {
        return this.settings;
      },
      set: function (value) {
        this.$emit('settings', value);
      },
    },
    previewPdf: function () {
      const presetType = this.settingsLocal.presetType;
      if (presetType === 'orders') {
        return {
          bgFirst: 'Vorlage_Seite1.png',
          bgFollowing: 'Vorlage.png',
        };
      }
      const getPresetName = () => {
        switch (presetType) {
          case 'reports':
            return 'Reports';
          case 'statistics':
            return 'Statistics';
        }
      };

      return {
        bgFirst: getPresetName() + '_Background_1.png',
        bgFollowing: getPresetName() + '_Background_X.png',
      };
    },
  },
  methods: {
    errorImgLoaded(key) {
      this.previewPdfLoaded[key] = false;
    },
    imgLoaded(key) {
      this.previewPdfLoaded[key] = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.img-wrapper {
  padding-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.img-preview {
  width: 100%;
  box-shadow: 0px 0px 20px 1px rgba(0, 0, 0, 0.21);
}
</style>
